export const scrollTo = () => {
  window.scrollTo({top: 0, behavior: 'smooth'})
}